import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import getLeads from "../../services/getLeads";
import getTag from "../../services/getTag";
import deleteLeads from "../../services/deleteLeads";
import generateExcel from "../../services/generateExcel";
import Constants from "../../utils/consts";
import getCategorieTag from "../../services/getCategorieTag";
import addLeads from "../../services/addLeads";
import updateLeads from "../../services/updateLeads";
import setLeadVisto from "../../services/setLeadVisto";
import { LeadsContext } from "../../context/LeadsContext";

export default class Leads extends React.Component {
  static contextType = LeadsContext;

  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    // Recupera i filtri salvati dal localStorage
    const getSavedFilters = () => {
      try {
        const savedSelectedTags = localStorage.getItem("leads_selectedTags");
        const savedExcludedTags = localStorage.getItem("leads_excludedTags");
        const savedDataInizio = localStorage.getItem("leads_dataInizio");
        const savedDataFine = localStorage.getItem("leads_dataFine");
        const savedDateFilterType = localStorage.getItem(
          "leads_dateFilterType",
        );

        const filters = {
          selectedTags: savedSelectedTags ? JSON.parse(savedSelectedTags) : [],
          excludedTags: savedExcludedTags ? JSON.parse(savedExcludedTags) : [],
          dataInizio: savedDataInizio ? JSON.parse(savedDataInizio) : null,
          dataFine: savedDataFine ? JSON.parse(savedDataFine) : null,
          dateFilterType: savedDateFilterType || "data_creazione",
        };

        console.log("🔄 Filtri recuperati dal localStorage:", filters);
        return filters;
      } catch (e) {
        console.error("❌ Errore nel recupero dei filtri:", e);
        return {
          selectedTags: [],
          excludedTags: [],
          dataInizio: null,
          dataFine: null,
          dateFilterType: "data_creazione",
        };
      }
    };

    const savedFilters = getSavedFilters();

    this.grid = 2;

    this.pdfElements = [];

    this.studenti = [];
    this.pageTitle = "Leads";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });

    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();
    this.fileInputRef = React.createRef();

    this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
    this.handleCorsiChange = this.handleCorsiChange.bind(this);

    this.tags = [];

    // Stato unificato con i filtri salvati
    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: [],
      leads: [],
      studenti: [],
      selectedTags: savedFilters.selectedTags,
      excludedTags: savedFilters.excludedTags,
      dataInizio: savedFilters.dataInizio,
      dataFine: savedFilters.dataFine,
      dateFilterType: savedFilters.dateFilterType,
      selectedLeads: [],
    };
  }

  handleCategoriaChange(option) {
    this.setState({ selectedCategoria: option, selectedCorsi: null }, () => {
      this.reload();
    });
  }

  handleCorsiChange(option) {
    this.setState({ selectedCorsi: option }, () => {
      this.reload();
    });
  }

  handleTagChange = (selectedTags) => {
    console.log("💾 Salvataggio selectedTags:", selectedTags);
    localStorage.setItem("leads_selectedTags", JSON.stringify(selectedTags));
    this.setState({ selectedTags: selectedTags }, () => {
      this.reload();
    });
  };

  handleDataInizioChange = (dataInizio) => {
    console.log("💾 Salvataggio dataInizio:", dataInizio);
    localStorage.setItem("leads_dataInizio", JSON.stringify(dataInizio));
    this.setState({ dataInizio: dataInizio }, () => {
      this.reload();
    });
  };

  handleDataFineChange = (dataFine) => {
    console.log("💾 Salvataggio dataFine:", dataFine);
    localStorage.setItem("leads_dataFine", JSON.stringify(dataFine));
    this.setState({ dataFine: dataFine }, () => {
      this.reload();
    });
  };

  handleDateFilterTypeChange = (event) => {
    const dateFilterType = event.target.value;
    console.log("💾 Salvataggio dateFilterType:", dateFilterType);
    localStorage.setItem("leads_dateFilterType", dateFilterType);
    this.setState({ dateFilterType }, () => {
      this.reload();
    });
  };

  handleTagRemoveChange = (removedTags) => {
    console.log("💾 Salvataggio excludedTags:", removedTags);
    localStorage.setItem("leads_excludedTags", JSON.stringify(removedTags));
    this.setState(
      {
        excludedTags: removedTags,
      },
      () => {
        this.reload();
      },
    );
  };

  handleResetFilters = () => {
    console.log("🧹 Reset completo di tutti i filtri e ordinamenti");
    // Pulisce tutti i filtri dal localStorage
    localStorage.removeItem("leads_selectedTags");
    localStorage.removeItem("leads_excludedTags");
    localStorage.removeItem("leads_dataInizio");
    localStorage.removeItem("leads_dataFine");
    localStorage.removeItem("leads_table_searchText");
    localStorage.removeItem("leads_table_order");
    localStorage.removeItem("leads_table_orderBy");
    localStorage.removeItem("leads_table_page");

    // Resetta i filtri nello stato
    this.handleTagChange([]);
    this.handleTagRemoveChange([]);
    this.handleDataInizioChange("");
    this.handleDataFineChange("");
  };

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.leads = await getLeads(username, token);
    this.tags = await getTag(username, token);
    this.categorieTags = await getCategorieTag(username, token);

    const filteredLeads = this.leads.filter((lead) => {
      const tagIds = lead.tag_id
        ? lead.tag_id.split(",").map((tagId) => Number(tagId))
        : [];

      // Seleziona la data su cui filtrare in base al tipo di filtro scelto
      // - data_creazione  -> data di creazione del lead (immutabile)
      // - data_modifica   -> data ultima attività (data_ultimo_contatto || data_modifica || data_creazione)
      // - data_iscrizione -> data di iscrizione del lead
      const filterType = this.state.dateFilterType || "data_creazione";
      let dataLeadStr = null;
      if (filterType === "data_modifica") {
        dataLeadStr =
          lead.data_ultimo_contatto ||
          lead.data_modifica ||
          lead.data_creazione;
      } else if (filterType === "data_iscrizione") {
        dataLeadStr = lead.data_iscrizione;
      } else {
        dataLeadStr = lead.data_creazione;
      }
      // Se filtriamo per data_iscrizione e il lead non è iscritto, escludilo quando è impostato un range
      if (
        filterType === "data_iscrizione" &&
        !dataLeadStr &&
        (this.state.dataInizio || this.state.dataFine)
      ) {
        return false;
      }
      const dataLead = dataLeadStr ? new Date(dataLeadStr) : null;

      if (this.state.dataInizio && dataLead) {
        const dataInizio = new Date(this.state.dataInizio);
        // Inizio giornata 00:00:00
        dataInizio.setHours(0, 0, 0, 0);
        if (dataLead < dataInizio) {
          return false;
        }
      }

      if (this.state.dataFine && dataLead) {
        const dataFine = new Date(this.state.dataFine);
        // Fine giornata 23:59:59.999 -> rende inclusivo l'ultimo giorno
        dataFine.setHours(23, 59, 59, 999);
        if (dataLead > dataFine) {
          return false;
        }
      }

      if (this.state.excludedTags && this.state.excludedTags.length > 0) {
        const excludedTagValues = this.state.excludedTags.map((tag) =>
          Number(tag.value),
        );
        if (tagIds.some((tagId) => excludedTagValues.includes(tagId))) {
          return false;
        }
      }

      if (!this.state.selectedTags || this.state.selectedTags.length === 0) {
        return true;
      }

      return this.state.selectedTags.every((tag) =>
        tagIds.includes(Number(tag.value)),
      );
    });

    const leadsWithTags = filteredLeads.map((lead) => {
      const tagIds = lead.tag_id ? lead.tag_id.split(",") : [];

      const tagNames = tagIds.map((tagId) => {
        const tag = this.tags.find((tag) => tag.id == tagId);
        return tag ? tag.tag : null;
      });

      const origineTags = [];
      const corsoTags = [];
      const infoDateTags = [];
      const noteTags = [];
      const provenienzeTags = [];

      tagIds.forEach((tagId) => {
        const tag = this.tags.find((tag) => tag.id == tagId);
        if (tag) {
          const categoria = this.categorieTags.find(
            (categoria) => categoria.id == tag.id_categoria,
          );
          if (categoria) {
            if (categoria.nome === "ORIGINE") {
              origineTags.push(tag.tag);
            } else if (categoria.nome === "CORSO") {
              corsoTags.push(tag.tag);
            } else if (categoria.nome === "INFO DATE") {
              infoDateTags.push(tag.tag);
            } else if (categoria.nome === "NOTE") {
              noteTags.push(tag.tag);
            } else if (categoria.nome === "PROVENIENZE") {
              provenienzeTags.push(tag.tag);
            }
          }
        }
      });

      // Data riferimento per la colonna "Ultima attività":
      // - data_ultimo_contatto se esiste (lead duplicato dal form, o modifica significativa)
      // - altrimenti data_creazione
      const dataUltimaAttivita =
        lead.data_ultimo_contatto || lead.data_creazione;
      const dateOnlyAttivita = dataUltimaAttivita
        ? dataUltimaAttivita.split(" ")[0]
        : "";

      // Data creazione REALE (immutabile): utile al marketing per tracciare i lead davvero nuovi
      const dateOnlyCreazione = lead.data_creazione
        ? lead.data_creazione.split(" ")[0]
        : "";

      const dataIscrizioneFormatted = lead.data_iscrizione
        ? lead.data_iscrizione.split(" ")[0]
        : "";

      // Formatta data in DD/MM/YYYY (formato italiano standard)
      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split("-");
        if (parts.length !== 3) return dateStr;
        return `${parts[2]}/${parts[1]}/${parts[0]}`; // Da YYYY-MM-DD a DD/MM/YYYY
      };

      return {
        ...lead,
        tag_name: tagNames.length > 0 ? tagNames.join(", ") : "",
        origine: origineTags.length > 0 ? origineTags.join(", ") : "",
        corso: corsoTags.length > 0 ? corsoTags.join(", ") : "",
        info_date: infoDateTags.length > 0 ? infoDateTags.join(", ") : "",
        note: noteTags.length > 0 ? noteTags.join(", ") : "",
        provenienze:
          provenienzeTags.length > 0 ? provenienzeTags.join(", ") : "",
        // ✅ Vera data di creazione (immutabile) — per ordinare i lead realmente nuovi
        data_creazione_reale: formatDate(dateOnlyCreazione),
        // Mantiene il vecchio campo "data_creazione" che in realtà mostra l'ultima attività,
        // per non rompere altri usi nel codice. Usato come default sort della tabella.
        data_creazione_raw: dataUltimaAttivita,
        data_creazione: formatDate(dateOnlyAttivita),
        // Nuovo alias semantico per chi vuole l'ultima attività
        ultima_attivita: formatDate(dateOnlyAttivita),
        data_iscrizione: formatDate(dataIscrizioneFormatted),
      };
    });

    this.setState({
      leads: leadsWithTags,
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  // Segna tutti i lead come visti
  markAllAsRead = async () => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const unreadLeads = this.state.leads.filter(
      (lead) => lead.visto === 0 || lead.visto === "0",
    );

    if (unreadLeads.length === 0) {
      alert("Non ci sono lead non visti da segnare.");
      return;
    }

    if (
      window.confirm(`Vuoi segnare ${unreadLeads.length} lead come visti?`) ===
      false
    ) {
      return;
    }

    try {
      await setLeadVisto(username, token, null, null, true);
      this.context.updateLeadsCount(0);
      await this.reload();
    } catch (error) {
      console.error("Errore nel segnare tutti come visti:", error);
      alert("Errore nel segnare tutti come visti.");
    }
  };

  // Segna un singolo lead come visto
  markLeadAsRead = async (leadId) => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    try {
      const result = await setLeadVisto(username, token, leadId);
      if (result && result.success) {
        this.context.updateLeadsCount((prev) => (prev > 0 ? prev - 1 : 0));
        // Aggiorna lo stato locale senza ricaricare tutto
        this.setState((prevState) => ({
          leads: prevState.leads.map((lead) =>
            lead.id === leadId ? { ...lead, visto: 1 } : lead,
          ),
        }));
      }
    } catch (error) {
      console.error("Errore nel segnare come visto:", error);
    }
  };

  download = async (leads) => {
    this.setState({ loading: true });

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    // Creo l'header della tabella
    const headers = [
      "Data modifica",
      "Nome",
      "Cognome",
      "Email",
      "Telefono",
      "Età",
      "Città",
      "Corso",
      "Origine",
      "Info Date",
      "Provenienze",
      "Note",
      "Data iscrizione",
      "Tutti i Tags",
    ];

    // Creo i dati della tabella
    const tableData = leads.map((lead) => [
      lead.data_modifica || "",
      lead.nome || "",
      lead.cognome || "",
      lead.mail || "",
      lead.telefono || "",
      lead.eta || "",
      lead.citta || "",
      lead.corso || "",
      lead.origine || "",
      lead.info_date || "",
      lead.provenienze || "",
      lead.note || "",
      lead.data_iscrizione || "",
      lead.tag_name || "",
    ]);

    // Aggiungo l'header come prima riga
    const excelData = [headers, ...tableData];

    // Creo la struttura JSON per generateExcel
    const jsonTabs = [
      {
        name: "Leads",
        data: excelData,
      },
    ];

    const json = {
      tabs: jsonTabs,
    };

    const fileName = `leads_${new Date().toISOString().split("T")[0]}`;

    try {
      await generateExcel(username, token, JSON.stringify(json), fileName);

      // Piccolo delay per assicurarsi che il file sia stato generato sul server
      await new Promise((resolve) => setTimeout(resolve, 500));

      window.open(`${Constants.mainUrl}pdf/${fileName}.xlsx`, "_blank");
    } catch (error) {
      console.error("Errore durante l'esportazione:", error);
      alert("Si è verificato un errore durante l'esportazione.");
    }

    this.setState({ loading: false });
  };

  // ✅ Funzione per rilevare automaticamente il separatore CSV
  detectCSVSeparator = (csvContent) => {
    const firstLine = csvContent.split("\n")[0];
    const semicolonCount = (firstLine.match(/;/g) || []).length;
    const commaCount = (firstLine.match(/,/g) || []).length;

    // Se ci sono più punti e virgola che virgole, usa il punto e virgola
    return semicolonCount > commaCount ? ";" : ",";
  };

  // ✅ Funzione per gestire valori null/undefined/non-stringa in modo sicuro
  safeTrim = (value) => {
    if (value === null || value === undefined) return "";
    const stringValue = String(value);
    return stringValue.trim();
  };

  // ✅ Funzione per dividere stringhe in modo sicuro
  safeSplit = (value, separator) => {
    if (!value || value === null || value === undefined) return [];
    const stringValue = String(value);
    return stringValue
      .split(separator)
      .map((item) => this.safeTrim(item))
      .filter((item) => item.length > 0);
  };

  // ✅ Funzione di validazione email migliorata
  isValidEmail = (email) => {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  // ✅ Funzione per processare il file CSV con supporto per entrambi i separatori
  processCSV = async (csvContent) => {
    try {
      // Rileva automaticamente il separatore
      const separator = this.detectCSVSeparator(csvContent);
      console.log(`Separatore rilevato: "${separator}"`);

      const lines = csvContent.split("\n").filter((line) => line.trim());
      if (lines.length <= 1) {
        alert("File CSV vuoto o senza dati");
        return;
      }

      // Parsing della riga di intestazione con gestione sicura
      const headers = lines[0].split(separator).map((header) => {
        if (header === null || header === undefined) return "";
        let stringHeader = String(header).trim();
        // Rimuovi le virgolette se presenti
        if (stringHeader.startsWith('"') && stringHeader.endsWith('"')) {
          stringHeader = stringHeader.slice(1, -1);
        }
        return stringHeader;
      });
      console.log("Headers trovati:", headers);

      // Contatori per feedback dettagliato
      let processedCount = 0;
      let skippedCount = 0;
      let errorCount = 0;
      const skippedReasons = [];

      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });

      // Processa ogni riga di dati
      for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) {
          skippedCount++;
          skippedReasons.push(`Riga ${i + 1}: Riga vuota`);
          continue;
        }

        // ✅ Gestione robusta dei valori per evitare errori str.replace
        const values = line.split(separator).map((value) => {
          // Gestisce valori null/undefined/non-stringa
          if (value === null || value === undefined) return "";
          let stringValue = String(value).trim();
          // Rimuovi le virgolette se presenti
          if (stringValue.startsWith('"') && stringValue.endsWith('"')) {
            stringValue = stringValue.slice(1, -1);
          }
          return stringValue;
        });

        // Crea un oggetto con i dati della riga
        const rowData = {};
        headers.forEach((header, index) => {
          const value = values[index];
          // Assicura che il valore sia sempre una stringa e gestisce casi edge
          const safeValue =
            value !== null && value !== undefined ? String(value).trim() : "";
          rowData[header.toLowerCase().trim()] = safeValue;
        });

        // ✅ Validazione campi obbligatori con gestione sicura dei valori
        const nome = this.safeTrim(rowData.nome || rowData.name || "");
        const cognome = this.safeTrim(
          rowData.cognome || rowData.surname || rowData.lastname || "",
        );
        const telefono = this.safeTrim(
          rowData.telefono || rowData.phone || rowData.numero || "",
        );
        const email = this.safeTrim(rowData.email || rowData.mail || "");

        // Controlli di validazione stringenti
        const errors = [];

        if (!nome || nome.length < 2) {
          errors.push("Nome mancante o troppo corto");
        }

        if (!cognome || cognome.length < 2) {
          errors.push("Cognome mancante o troppo corto");
        }

        if (!telefono || telefono.length < 8) {
          errors.push("Numero di telefono mancante o troppo corto");
        }

        // Validazione email opzionale ma se presente deve essere valida
        if (email && !this.isValidEmail(email)) {
          errors.push("Formato email non valido");
        }

        if (errors.length > 0) {
          skippedCount++;
          skippedReasons.push(`Riga ${i + 1}: ${errors.join(", ")}`);
          continue;
        }

        // ✅ Controllo duplicati per telefono ed email
        const isDuplicatePhone =
          telefono &&
          this.leads.some(
            (existingLead) =>
              existingLead.telefono &&
              existingLead.telefono.trim() === telefono.trim(),
          );

        const isDuplicateEmail =
          email &&
          this.leads.some(
            (existingLead) =>
              existingLead.mail &&
              existingLead.mail.toLowerCase().trim() ===
                email.toLowerCase().trim(),
          );

        if (isDuplicatePhone || isDuplicateEmail) {
          skippedCount++;
          const duplicateReasons = [];
          if (isDuplicatePhone)
            duplicateReasons.push(`telefono "${telefono}" già esistente`);
          if (isDuplicateEmail)
            duplicateReasons.push(`email "${email}" già esistente`);
          skippedReasons.push(
            `Riga ${i + 1}: Duplicato - ${duplicateReasons.join(" e ")}`,
          );
          continue;
        }

        try {
          // ✅ Gestione robusta dei tag con separatore corretto
          const origine = this.safeTrim(rowData.origine || "");
          const corso = this.safeTrim(rowData.corso || "");
          const infoDate = this.safeTrim(
            rowData["info date"] || rowData.info_date || rowData.infodate || "",
          );
          const note = this.safeTrim(rowData.note || rowData.notes || "");
          const classe = this.safeTrim(rowData.classe || rowData.class || "");
          const provenienze = this.safeTrim(
            rowData.provenienze || rowData.provenienza || "",
          );
          const speciali = this.safeTrim(
            rowData.speciali || rowData.special || "",
          );
          const appuntamentoIscrizione = this.safeTrim(
            rowData["appuntamento iscrizione"] ||
              rowData.appuntamento_iscrizione ||
              rowData.appuntamento ||
              "",
          );

          let allTags = [];

          // ✅ Parsing sicuro dei tag usando virgola come separatore per i tag
          if (origine) {
            const origineTags = this.safeSplit(origine, ",");
            allTags = allTags.concat(origineTags);
          }

          if (corso) {
            const corsoTags = this.safeSplit(corso, ",");
            allTags = allTags.concat(corsoTags);
          }

          if (infoDate) {
            const infoDateTags = this.safeSplit(infoDate, ",");
            allTags = allTags.concat(infoDateTags);
          }

          if (note) {
            const noteTags = this.safeSplit(note, ",");
            allTags = allTags.concat(noteTags);
          }

          if (classe) {
            const classeTags = this.safeSplit(classe, ",");
            allTags = allTags.concat(classeTags);
          }

          if (provenienze) {
            const provenienzeTags = this.safeSplit(provenienze, ",");
            allTags = allTags.concat(provenienzeTags);
          }

          if (speciali) {
            const specialiTags = this.safeSplit(speciali, ",");
            allTags = allTags.concat(specialiTags);
          }

          if (appuntamentoIscrizione) {
            const appuntamentoTags = this.safeSplit(
              appuntamentoIscrizione,
              ",",
            );
            allTags = allTags.concat(appuntamentoTags);
          }

          // ✅ Converti i nomi dei tag in ID numerici
          const tagIds = [];
          allTags.forEach((tagName) => {
            const trimmedTagName = tagName.trim();
            const foundTag = this.tags.find(
              (tag) => tag.tag.toLowerCase() === trimmedTagName.toLowerCase(),
            );
            if (foundTag) {
              tagIds.push(foundTag.id);
            } else {
              console.warn(`Tag non trovato: "${trimmedTagName}"`);
            }
          });

          console.log("Tag nomi:", allTags);
          console.log("Tag IDs convertiti:", tagIds);

          // Prepara i parametri per il servizio addLeads (assicura che siano sempre stringhe)
          const tagString = tagIds.length > 0 ? tagIds.join(",") : "";
          const cittaValue = this.safeTrim(
            rowData.citta || rowData.città || rowData.city || "",
          );
          const etaValue = this.safeTrim(
            rowData.eta || rowData.età || rowData.age || "",
          );
          const dataIscrizioneValue = this.safeTrim(
            rowData["data iscrizione"] ||
              rowData.data_iscrizione ||
              rowData.dataIscrizione ||
              "",
          );
          const prenotazioneChiamataValue = this.safeTrim(
            rowData["prenotazione chiamata"] ||
              rowData.prenotazione_chiamata ||
              rowData.prenotazione ||
              "",
          );

          console.log("Dati estratti:", {
            nome,
            cognome,
            email,
            telefono,
            tagString,
            dataIscrizioneValue,
            etaValue,
            cittaValue,
            prenotazioneChiamataValue,
          });

          // Chiama il servizio per aggiungere il lead con la signature corretta
          const result = await addLeads(
            username,
            token,
            String(cognome), // Assicura stringa
            String(nome), // Assicura stringa
            String(email), // Assicura stringa
            String(tagString), // Assicura stringa
            String(telefono), // Assicura stringa
            String(dataIscrizioneValue), // ✅ Ora passiamo la data dal CSV
            String(etaValue), // ✅ Ora passiamo l'età dal CSV
            String(cittaValue), // Assicura stringa
          );

          console.log("Risposta dal server:", result);

          if (result && result.result === "ok") {
            processedCount++;
            console.log(`Lead ${nome} ${cognome} salvato con successo`);

            // ✅ Se c'è una prenotazione chiamata, aggiorna il lead
            if (prenotazioneChiamataValue && result.id) {
              try {
                console.log(
                  `Aggiornamento prenotazione per lead ID: ${result.id}`,
                );
                await updateLeads(
                  username,
                  token,
                  result.id,
                  String(cognome),
                  String(nome),
                  String(email),
                  String(tagString),
                  String(telefono),
                  String(prenotazioneChiamataValue), // prenotazione
                  String(dataIscrizioneValue),
                  String(etaValue),
                  String(cittaValue),
                );
                console.log(`Prenotazione aggiornata per ${nome} ${cognome}`);
              } catch (updateError) {
                console.warn(
                  `Errore aggiornamento prenotazione per ${nome} ${cognome}:`,
                  updateError,
                );
                // Non blocco il processo per un errore di aggiornamento della prenotazione
              }
            }
          } else {
            errorCount++;
            const errorMsg =
              result && result.message
                ? result.message
                : "Errore sconosciuto del server";
            skippedReasons.push(
              `Riga ${i + 1}: Errore nel salvataggio sul server - ${errorMsg}`,
            );
            console.error("Errore dal server:", result);
          }
        } catch (error) {
          errorCount++;
          // ✅ Gestione migliorata degli errori con più dettagli
          let errorMessage = "Errore sconosciuto";
          if (error && error.message) {
            errorMessage = error.message;
          } else if (typeof error === "string") {
            errorMessage = error;
          }

          skippedReasons.push(
            `Riga ${i + 1}: Errore durante il processing - ${errorMessage}`,
          );
          console.error(`Errore processing riga ${i + 1}:`, {
            error,
            lineContent: line,
            values,
            rowData,
          });
        }
      }

      // ✅ Feedback dettagliato finale all'utente
      let message = `Importazione completata!\n\n`;
      message += `📊 Statistiche:\n`;
      message += `✅ Lead processati con successo: ${processedCount}\n`;
      message += `⚠️ Righe saltate: ${skippedCount}\n`;
      message += `❌ Errori: ${errorCount}\n`;
      message += `📋 Totale righe elaborate: ${processedCount +
        skippedCount +
        errorCount}\n\n`;

      if (skippedReasons.length > 0) {
        message += `📝 Dettagli righe saltate/errori:\n`;
        const maxReasons = 10; // Mostra max 10 errori per non sovraccaricare
        skippedReasons.slice(0, maxReasons).forEach((reason) => {
          message += `• ${reason}\n`;
        });

        if (skippedReasons.length > maxReasons) {
          message += `... e altri ${skippedReasons.length -
            maxReasons} errori\n`;
        }
      }

      message += `\n🔄 La tabella verrà aggiornata automaticamente.`;

      alert(message);

      // Aggiorna la vista
      this.reload();
    } catch (error) {
      console.error("Errore durante il processing del CSV:", error);
      alert(`Errore durante l'importazione del file CSV: ${error.message}`);
    }
  };

  // ✅ Gestione selezione file
  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Controlla che sia un file CSV
    if (!file.name.toLowerCase().endsWith(".csv")) {
      alert("Per favore seleziona un file CSV valido");
      return;
    }

    // Legge il contenuto del file
    const reader = new FileReader();
    reader.onload = (e) => {
      const csvContent = e.target.result;
      this.processCSV(csvContent);
    };
    reader.readAsText(file);

    // Reset dell'input per permettere di selezionare lo stesso file di nuovo se necessario
    event.target.value = "";
  };

  // ✅ Gestione click bottone importa
  handleFileImport = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  render() {
    const headCells = [
      {
        id: "data_creazione_reale",
        numeric: true,
        disablePadding: false,
        label: "Data creazione",
      },
      {
        id: "data_creazione",
        numeric: true,
        disablePadding: false,
        label: "Ultima attività",
      },
      { id: "nome", numeric: true, disablePadding: false, label: "Nome" },
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      {
        id: "telefono",
        numeric: true,
        disablePadding: false,
        label: "Telefono",
      },
      {
        id: "corso",
        numeric: true,
        disablePadding: false,
        label: "Corso",
      },
      {
        id: "origine",
        numeric: true,
        disablePadding: false,
        label: "Origine",
      },
      {
        id: "info_date",
        numeric: true,
        disablePadding: false,
        label: "Info Date",
      },
      {
        id: "provenienze",
        numeric: true,
        disablePadding: false,
        label: "Prov.",
      },
      {
        id: "note",
        numeric: true,
        disablePadding: false,
        label: "Note",
      },
      {
        id: "data_iscrizione",
        numeric: true,
        disablePadding: false,
        label: "Data iscrizione",
      },
      {
        id: "prenotazione",
        numeric: true,
        disablePadding: false,
        label: "Prenotazione",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = [
      "nome",
      "cognome",
      "mail",
      "telefono",
      "corso",
      "origine",
      "info_date",
      "provenienze",
      "note",
      "data_modifica",
      "data_iscrizione",
      "prenotazione",
    ];

    const cookies = new Cookies();

    const formattedTags = this.tags.map((tag) => ({
      value: tag.id,
      label: tag.tag,
    }));

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          {/* Input file nascosto per l'importazione */}
          <input
            type="file"
            ref={this.fileInputRef}
            style={{ display: "none" }}
            accept=".csv"
            onChange={this.handleFileChange}
          />

          <PageTitle
            title={this.pageTitle}
            button="NUOVO"
            secondButton="ESPORTA"
            thirdButton="IMPORTA"
            fourthButton="SEGNA VISTI"
            onClick={() => {
              window.location.href = "/#/app/addLead";
            }}
            onSecondClick={() => {
              this.download(this.state.leads);
            }}
            onThirdClick={this.handleFileImport}
            onFourthClick={this.markAllAsRead}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "10px 0",
              paddingLeft: "20px",
            }}
          >
            <label
              htmlFor="leads-date-filter-type"
              style={{ fontWeight: "bold", fontSize: "0.9em" }}
            >
              Filtra per data:
            </label>
            <select
              id="leads-date-filter-type"
              value={this.state.dateFilterType || "data_creazione"}
              onChange={this.handleDateFilterTypeChange}
              style={{
                padding: "5px 10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "0.9em",
              }}
            >
              <option value="data_creazione">Data creazione</option>
              <option value="data_modifica">Ultima attività</option>
              <option value="data_iscrizione">Data iscrizione</option>
            </select>
          </div>

          <Table
            storageKey="leads_table"
            headCells={headCells}
            searchCols={this.searchCols}
            assenze={false}
            calendar={false}
            onChangeCategoria={this.handleCategoriaChange}
            onChangeCorsi={this.handleCorsiChange}
            onChangeDataInizio={this.handleDataInizioChange}
            onChangeDataFine={this.handleDataFineChange}
            dataInizio={this.state.dataInizio}
            dataFine={this.state.dataFine}
            desc
            orderBy="data_creazione"
            filterTags={formattedTags}
            handleTagChange={this.handleTagChange}
            removeTags
            handleTagRemoveChange={this.handleTagRemoveChange}
            selectedTags={this.state.selectedTags}
            excludedTags={this.state.excludedTags}
            onResetFilters={this.handleResetFilters}
            pdf={false}
            excel={false}
            mail={false}
            phone={false}
            rows={this.state.leads}
            onEventClick={async (row) => {
              // Segna il lead come visto se non lo è già
              if (row.visto === 0 || row.visto === "0") {
                await this.markLeadAsRead(row.id);
              }
              cookies.set("currentCrm", row, { path: "/" });
              window.location.href = "/#/app/editLead";
            }}
            onPdfClicked={(row) => {
              cookies.set("requestedStudent", row, { path: "/" });
              window.location.href = "/#/app/pdfSingleStudent";
            }}
            onSendMail={(id) => {
              this.sendMailRef.current && this.sendMailRef.current.reset();
              this.setState({ sendMailVisible: true, sendMailUserId: id });
            }}
            onSendNotification={(id) => {
              this.sendNotificationRef.current &&
                this.sendNotificationRef.current.reset();
              this.setState({
                sendNotificationVisible: true,
                notificationUser: id,
              });
            }}
            onDelete={async (id) => {
              if (
                window.confirm("Sei sicuro di voler eliminare il lead?") ==
                false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteLeads(username, token, id);
              this.reload();
            }}
            onElementCheck={async (companyId) => {
              const cookies = new Cookies();

              var json = cookies.get("checksList", { path: "/" });
              var checksList = json.list;
              var index = checksList.indexOf(companyId);
              if (index != -1) checksList.splice(index, 1);
              else checksList.push(companyId);

              cookies.set("checksList", JSON.stringify({ list: checksList }), {
                path: "/",
              });
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </>
    );
  }
}
